import { ChevronLeft as ChevronLeftIcon } from '@mui/icons-material'
import { Button, Container, Paper, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { T } from '@/helpers/T'
import { useNavigateGoBack } from '@/hooks/useNavigateGoBack'
import { useAuthContext } from '@/providers/Global'
import { withLoggedInRoute } from '@/router/LoggedInRoute'

//	///////////////////////
//	MARK: CONFIG
const USERNAME_PREFIX = '/login-'

//	///////////////////////
//	MARK: EXPORTS
const E404Index: React.FC = () => {
  const Auth = useAuthContext()
  const location = useLocation()
  const navigate = useNavigate()
  const navigateGoBack = useNavigateGoBack()

  useEffect(() => {
    if (location.pathname.startsWith(USERNAME_PREFIX)) {
      const separatorPrefix = location.pathname.slice(1).indexOf('/')
      const username = location.pathname.slice(USERNAME_PREFIX.length, separatorPrefix + 1)

      if (Auth.active?.username !== username) {
        if (Auth.active) {
          Auth.changeSession()
          return
        }

        const session = Auth.sessions.find((e) => e.username === username)

        if (session) {
          Auth.changeSession(session)
        }
      }

      navigate(location.pathname.slice(separatorPrefix + 1))
    }
  }, [Auth, location.pathname, navigate])

  return (
    <Container maxWidth='sm' sx={{ mt: 4, textAlign: 'center' }}>
      <Paper sx={{ p: 5 }}>
        <Typography variant='h3' mb={2}>
          <T id='r.404.title' />
        </Typography>
        <Typography variant='h6' color='primary' mb={2}>
          {location.pathname}
        </Typography>
        <Typography variant='body1' mb={3}>
          <T id='r.404.text' />
        </Typography>
        <Button startIcon={<ChevronLeftIcon />} onClick={navigateGoBack}>
          <T id='r.404.button' />
        </Button>
      </Paper>
    </Container>
  )
}

export default withLoggedInRoute(React.memo(E404Index))
